module.exports = __webpack_public_path__ + "static/media/Occassions.8c054a01.svg";